export const create_UUID = () => {
    var currentdate = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (uniqueChar) {
        var convertDate = (currentdate + Math.random() * 16) % 16 | 0;
        currentdate = Math.floor(currentdate / 16);
        return (uniqueChar === "x" ? convertDate : (convertDate & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};